import React, { useEffect, useState } from 'react'
import { globalGetService } from '../../../../globalServices';
import { checkApiStatus } from '../../../utils_v2';
import ConfigData from '../../master/components/ConfigData';
import { Grid, Paper, Tab, Tabs, TextField, Typography } from '@material-ui/core';
import { Link } from 'react-router';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { PageLoader } from '../../../shared_elements';
import { numberWithCommas } from '../../../../utils';
import LlpParts from '../../engineLlpsConfig/pages/LlpParts';
import PrimaryLlpList from './PrimaryLlpList';
import SvEvents from '../../maintenancePrograms/pages/SvEvents';

const EngineTypeView = () => {

    const [tabValue, setTabValue] = useState(0);
    const [engineTypeViewInfo, setEngineTypeViewInfo] = useState({});
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
      getEngineTypeView();
    },[])

    const FrontendUrl = window.location.pathname;
    const path = FrontendUrl.split('/');
    const id = path[path.length-1];

    const getEngineTypeView = (query) => {
      setLoading(true)
      globalGetService(`config-data/engine-type/${id}/`, query)
        .then(response => {
            if(checkApiStatus(response)) {
                setEngineTypeViewInfo(response?.data?.data)
            }
            setLoading(false)
        })
    }

    const handleTabChange = (event,newValue) => {
         setTabValue(newValue)
    }


  return (
     <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ padding: "10px" }}>
                    <div style={{ display: "flex", alignItems: 'center' }}>
                        <Link to="/config-data/engineTypes/" fontSize="small" classname="back-icon" style={{ color: "#3f51b5" }}><ArrowBackIcon style={{ color: "#3f51b5", verticalAlign: 'top' }} /></Link>
                        <Typography variant="h7" >{engineTypeViewInfo?.name}</Typography>
                    </div>
                    <div className='console-management-modal' style={{ padding: "0px 10px" }}>
                        <Grid container spacing={1}>
                            <Grid item md={4} >
                                <TextField
                                    name='engine_family'
                                    label='Engine Family'
                                    disabled
                                    value={engineTypeViewInfo?.engine_family?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4} >
                                <TextField
                                    name='aircraft_body_type'
                                    label='Aircraft Body Type'
                                    disabled
                                    value={engineTypeViewInfo?.aircraft_body_type?.label || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4} >
                                <TextField
                                    name='aircraft_type'
                                    label='Aircraft Type'
                                    disabled
                                    value={engineTypeViewInfo?.aircraft_type?.map((item) => item.name) || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={2} >
                                <TextField
                                    name='svc_escalation'
                                    label='SVC Escalation'
                                    disabled
                                    value={engineTypeViewInfo?.svc_escalation || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={2} >
                                <TextField
                                    name='svc_interval'
                                    label='SVC Interval'
                                    disabled
                                    value={engineTypeViewInfo?.svc_interval ? numberWithCommas(engineTypeViewInfo?.svc_interval) : ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={2} >
                                <TextField
                                    name='low_escalation'
                                    label='LOW Escalation'
                                    disabled
                                    value={engineTypeViewInfo?.low_escalation || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={2} >
                                <TextField
                                    name='low_interval'
                                    label='LOW Interval'
                                    disabled
                                    value={engineTypeViewInfo?.low_interval ? numberWithCommas(engineTypeViewInfo?.low_interval) : ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4} >
                                <TextField
                                    name='thrust'
                                    label='Thrust'
                                    disabled
                                    value={engineTypeViewInfo?.thrust?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled
                                    value={engineTypeViewInfo?.remarks || ''}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div square style={{ padding: '8px 10px' }}>
                        <Paper elevation={0} className="console-paper">
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab label="Primary LLP Part" />
                                <Tab label="Maintenance Program" />
                            </Tabs>
                        </Paper>
                        {tabValue === 0 && <PrimaryLlpList primaryLlpInfo={engineTypeViewInfo} />}
                        {tabValue === 1 && <SvEvents isEngine={true} deleted={engineTypeViewInfo.deleted_at}/>}
                    </div>
                </div>
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </section>
  )
}

export default EngineTypeView